import React, { useState } from "react";
import "./Form.css";

const Input = ({ label, ...props }) => (
  <div className="form-group">
    {label && <label className="form-label">{label}</label>}
    <input className="form-input" {...props} />
  </div>
);

const Textarea = ({ label, ...props }) => (
  <div className="form-group">
    {label && <label className="form-label">{label}</label>}
    <textarea className="form-input textarea" {...props} />
  </div>
);

const Button = (props) => (
  <button className="submit-button" {...props} />
);

export default function FormPage() {
  const [formData, setFormData] = useState({
    Nickname: "",
    Restaurant_Name: "",
    Country: "",
    City: "",
    DateMonth: "",
    DateYear: "",
    Tier: "",
    Price: "",
    Placement: "",
    MichelinStars: "",
    Cuisine: "",
    WebsiteLink: "",
    MichelinLink: "",
    MapLink: "",
    Review: "",
    photolink: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetch("http://localhost:5000/api/insert-restaurant", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });
    
  };

  return (
    <div className="form-container">
      <h1 className="form-title">Restaurant Dashboard Form</h1>
      <form onSubmit={handleSubmit} className="form-content">
        <Input label="Nickname" name="Nickname" value={formData.Nickname} onChange={handleChange} />
        <Input label="Restaurant Name" name="Restaurant_Name" value={formData.Restaurant_Name} onChange={handleChange} />
        <Input label="Country" name="Country" value={formData.Country} onChange={handleChange} />
        <Input label="City" name="City" value={formData.City} onChange={handleChange} />
        <Input label="Date Month" name="DateMonth" value={formData.DateMonth} onChange={handleChange} />
        <Input label="Date Year" name="DateYear" value={formData.DateYear} onChange={handleChange} />
        <Input label="Tier" name="Tier" value={formData.Tier} onChange={handleChange} />
        <Input label="Price" name="Price" value={formData.Price} onChange={handleChange} />
        <Input label="Placement" name="Placement" value={formData.Placement} onChange={handleChange} />
        <Input label="Michelin Stars" name="MichelinStars" value={formData.MichelinStars} onChange={handleChange} />
        <Input label="Cuisine" name="Cuisine" value={formData.Cuisine} onChange={handleChange} />
        <Input label="Website Link" name="WebsiteLink" value={formData.WebsiteLink} onChange={handleChange} />
        <Input label="Michelin Link" name="MichelinLink" value={formData.MichelinLink} onChange={handleChange} />
        <Input label="Map Link" name="MapLink" value={formData.MapLink} onChange={handleChange} />
        <Textarea label="Review" name="Review" value={formData.Review} onChange={handleChange} />
        <Textarea label="Photo Link" name="photolink" value={formData.photolink} onChange={handleChange} />
        <Button type="submit">Submit</Button>
      </form>
    </div>
  );
}
